(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["thinkcar-home-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('thinkcar-review-dialog')) {
    customElements.define('thinkcar-review-dialog', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;

        this.controller = new AbortController();
        const signal = this.controller.signal;
        const controls = document.querySelectorAll(`[aria-controls="${CSS.escape(this.dialog.id)}"]`);

        controls.forEach((control) => {
          control.addEventListener('click', (event) => {
            event.preventDefault();
            if (this.dialog.open) {
              this.dialog.close();
            }
            else {
              this.dialog.showModal();
            }
          }, { signal });
        });

        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        }, { signal });

        this.dialog.addEventListener('close', () => {
          controls.forEach((control) => control.setAttribute('aria-expanded', 'false'));
        }, { signal });

        this.dialog.addEventListener('toggle', () => {
          controls.forEach((control) => control.setAttribute('aria-expanded', this.dialog.open ? 'true' : 'false'));
        }, { signal });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thinkcar-home-why-thinkcar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('thinkcar-number-counter')) {
    customElements.define('thinkcar-number-counter', class extends HTMLElement {
      connectedCallback() {
        if (this.observer) return;
        this.observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.animate();
        }, { threshold: 0.35 });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }

      animate() {
        const original = this.dataset.value?.trim() || '0';
        const numeric = original.replace(/[^\d]/g, '');
        if (!numeric) {
          this.textContent = original;
          return;
        }
        const target = parseInt(numeric, 10) || 0;
        const leadingZeros = numeric.length > 1 && numeric.startsWith('0');
        const grouped = original.includes(',');
        const duration = (parseFloat(this.dataset.duration) || 1.5) * 1000;
        const start = performance.now();
        const tick = (time) => {
          const progress = Math.min((time - start) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 4);
          const value = Math.round(target * eased);
          if (progress === 1) {
            this.textContent = original;
          } else if (leadingZeros) {
            this.textContent = String(value).padStart(numeric.length, '0');
          } else if (grouped) {
            this.textContent = value.toLocaleString('en-US');
          } else {
            this.textContent = value;
          }
          if (progress < 1) this.frame = requestAnimationFrame(tick);
        };
        this.frame = requestAnimationFrame(tick);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thinkcar-scrollspy"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('thinkcar-product-scrollspy')) {
    customElements.define('thinkcar-product-scrollspy', class extends HTMLElement {
      connectedCallback() {
        this.links = Array.from(this.querySelectorAll('.thinkcar-product-scrollspy__link'));
        this.nav = this.querySelector('.thinkcar-product-scrollspy__nav');
        this.backToTopButton = this.querySelector('.thinkcar-product-scrollspy__back-to-top');
        this.currentLink = null;
        this.ticking = false;
        this.refreshTargets = this.refreshTargets.bind(this);
        this.updateActiveLink = this.updateActiveLink.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.handleTargetMutations = this.handleTargetMutations.bind(this);

        this.links.forEach((link) => {
          link.addEventListener('click', () => this.scrollToTarget(link));
        });
        this.backToTopButton?.addEventListener('click', () => {
          window.scrollTo({
            top: 0,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        });

        this.refreshTargets();
        window.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('resize', this.handleResize, { passive: true });
        document.addEventListener('shopify:section:load', this.refreshTargets);
        document.addEventListener('shopify:section:reorder', this.refreshTargets);
        document.addEventListener('shopify:section:unload', this.refreshTargets);
        window.addEventListener('load', this.refreshTargets, { once: true });

        this.targetObserver = new MutationObserver(this.handleTargetMutations);
        this.targetObserver.observe(document.documentElement, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
        document.removeEventListener('shopify:section:load', this.refreshTargets);
        document.removeEventListener('shopify:section:reorder', this.refreshTargets);
        document.removeEventListener('shopify:section:unload', this.refreshTargets);
        window.removeEventListener('load', this.refreshTargets);
        this.targetObserver?.disconnect();
        if (this.targetRefreshFrame) window.cancelAnimationFrame(this.targetRefreshFrame);
      }

      get aliases() {
        return {
          'main-product': ['main-product', 'main_product'],
          'overview': ['image-banner', 'image_banner', 'video-hero', 'video_hero', 'thinkcar-image-cards', 'thinkcar_image_cards'],
          'video-hero': ['video-hero', 'video_hero'],
          'image-with-text': ['image-with-text', 'image_with_text'],
          'comparison': ['product-comparison', 'product_comparison', 'comparison-table', 'comparison_table'],
          'product-details': ['product-details', 'product_details'],
          'faq': ['faq'],
          'creator-videos': ['thinkcar-home-creator-videos', 'thinkcar_home_creator_videos', 'thinkcar-creator-videos', 'thinkcar_creator_videos'],
          'customer-reviews': ['thinkcar-home-customer-reviews', 'thinkcar_home_customer_reviews', 'customer-reviews', 'customer_reviews']
        };
      }

      findTarget(link) {
        const targetType = link.dataset.targetSection;
        const customTarget = link.dataset.customTarget;
        const currentSection = this.closest('.shopify-section');
        const sections = Array.from(document.querySelectorAll('[id^="shopify-section-"]'));

        if (targetType === 'customer-reviews') {
          const judgeMeTarget = document.querySelector(
            '#judgeme_product_reviews, .jdgm-review-widget, [data-judgeme-product-reviews]'
          );
          if (judgeMeTarget) return judgeMeTarget;
        }

        if (targetType === 'custom' && customTarget) {
          const directTarget = document.getElementById(customTarget);
          if (directTarget) return directTarget;

          const customTokens = [customTarget.toLowerCase(), customTarget.toLowerCase().replaceAll('-', '_'), customTarget.toLowerCase().replaceAll('_', '-')];
          const customSection = sections.find((section) => {
            if (section === currentSection) return false;
            const normalizedId = section.id.toLowerCase();
            return customTokens.some((token) => normalizedId.includes(`__${token}`));
          });
          if (customSection) return customSection;
        }

        const tokens = this.aliases[targetType] || [targetType];

        return sections.find((section) => {
          if (section === currentSection) return false;
          const normalizedId = section.id.toLowerCase();
          return tokens.some((token) => normalizedId.includes(`__${token.toLowerCase()}`));
        }) || null;
      }

      refreshTargets() {
        this.links.forEach((link) => {
          const target = this.findTarget(link);
          link._thinkcarTarget = target;
          link.closest('.thinkcar-product-scrollspy__item').hidden = this.dataset.hideMissing === 'true' && !target;
        });
        this.updateActiveLink();
      }

      handleTargetMutations() {
        if (this.targetRefreshFrame) return;
        this.targetRefreshFrame = window.requestAnimationFrame(() => {
          this.refreshTargets();
          this.targetRefreshFrame = null;
        });
      }

      getScrollOffset() {
        const header = document.querySelector('.header-section header[is="sticky-header"]');
        const headerHeight = header ? header.getBoundingClientRect().height : 0;
        return headerHeight + this.getBoundingClientRect().height + 8;
      }

      scrollToTarget(link) {
        const target = link._thinkcarTarget;
        if (!target) return;
        const top = window.scrollY + target.getBoundingClientRect().top - this.getScrollOffset();
        window.scrollTo({
          top: Math.max(0, top),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }

      handleScroll() {
        if (this.ticking) return;
        this.ticking = true;
        window.requestAnimationFrame(() => {
          this.updateActiveLink();
          this.ticking = false;
        });
      }

      handleResize() {
        this.refreshTargets();
      }

      updateActiveLink() {
        const availableLinks = this.links.filter((link) => link._thinkcarTarget && !link.closest('.thinkcar-product-scrollspy__item').hidden);
        if (!availableLinks.length) return;

        const probeLine = this.getScrollOffset() + 2;
        let activeLink = availableLinks[0];

        availableLinks.forEach((link) => {
          if (link._thinkcarTarget.getBoundingClientRect().top <= probeLine) activeLink = link;
        });

        if (activeLink === this.currentLink) return;
        this.currentLink = activeLink;

        this.links.forEach((link) => {
          if (link === activeLink) {
            link.setAttribute('aria-current', 'location');
          } else {
            link.setAttribute('aria-current', 'false');
          }
        });

        if (window.matchMedia('(max-width: 767px)').matches) {
          const navRect = this.nav.getBoundingClientRect();
          const linkRect = activeLink.getBoundingClientRect();

          if (linkRect.left < navRect.left || linkRect.right > navRect.right) {
            const delta = linkRect.left - navRect.left - (navRect.width - linkRect.width) / 2;

            this.nav.scrollTo({
              left: this.nav.scrollLeft + delta,
              behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
            });
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
